import { createContext } from "react";
import type useAuthenticatedUser from "src/hooks/authentication/useAuthenticatedUser";

export interface IAuthenticatedUserContext extends ReturnType<typeof useAuthenticatedUser> {}

export const AuthenticatedUserContext = createContext<IAuthenticatedUserContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default AuthenticatedUserContext;
